import { render, staticRenderFns } from "./premium-upsell-modal.vue?vue&type=template&id=6c8f0a2c&"
import script from "./premium-upsell-modal.vue?vue&type=script&lang=js&"
export * from "./premium-upsell-modal.vue?vue&type=script&lang=js&"
import style0 from "./premium-upsell-modal.vue?vue&type=style&index=0&id=6c8f0a2c&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports